// countries.js

// Array con países de habla hispana, principales países europeos,
// y algunos de los principales países del mundo.
// Formato compatible con Semantic UI React (key, text, value).

export const countries = [
  // Países de habla hispana
  { key: "ar", text: "Argentina", value: "Argentina" },
  { key: "bo", text: "Bolivia", value: "Bolivia" },
  { key: "cl", text: "Chile", value: "Chile" },
  { key: "co", text: "Colombia", value: "Colombia" },
  { key: "cr", text: "Costa Rica", value: "Costa Rica" },
  { key: "cu", text: "Cuba", value: "Cuba" },
  { key: "do", text: "República Dominicana", value: "República Dominicana" },
  { key: "ec", text: "Ecuador", value: "Ecuador" },
  { key: "sv", text: "El Salvador", value: "El Salvador" },
  { key: "gt", text: "Guatemala", value: "Guatemala" },
  { key: "hn", text: "Honduras", value: "Honduras" },
  { key: "mx", text: "México", value: "México" },
  { key: "ni", text: "Nicaragua", value: "Nicaragua" },
  { key: "pa", text: "Panamá", value: "Panamá" },
  { key: "py", text: "Paraguay", value: "Paraguay" },
  { key: "pe", text: "Perú", value: "Perú" },
  { key: "pr", text: "Puerto Rico", value: "Puerto Rico" },
  { key: "es", text: "España", value: "España" },
  { key: "uy", text: "Uruguay", value: "Uruguay" },
  { key: "ve", text: "Venezuela", value: "Venezuela" },

  // Principales países europeos (además de España)
  { key: "de", text: "Alemania", value: "Alemania" },
  { key: "fr", text: "Francia", value: "Francia" },
  { key: "uk", text: "Reino Unido", value: "Reino Unido" },
  { key: "it", text: "Italia", value: "Italia" },
  { key: "pt", text: "Portugal", value: "Portugal" },
  { key: "nl", text: "Países Bajos", value: "Países Bajos" },
  { key: "be", text: "Bélgica", value: "Bélgica" },
  { key: "ch", text: "Suiza", value: "Suiza" },
  { key: "se", text: "Suecia", value: "Suecia" },
  { key: "no", text: "Noruega", value: "Noruega" },
  { key: "dk", text: "Dinamarca", value: "Dinamarca" },
  { key: "fi", text: "Finlandia", value: "Finlandia" },
  { key: "ie", text: "Irlanda", value: "Irlanda" },
  { key: "at", text: "Austria", value: "Austria" },
  { key: "pl", text: "Polonia", value: "Polonia" },
  { key: "cz", text: "Chequia", value: "Chequia" },
  { key: "hu", text: "Hungría", value: "Hungría" },
  { key: "gr", text: "Grecia", value: "Grecia" },

  // Principales países del mundo
  { key: "us", text: "Estados Unidos", value: "Estados Unidos" },
  { key: "ca", text: "Canadá", value: "Canadá" },
  { key: "br", text: "Brasil", value: "Brasil" },
  { key: "cn", text: "China", value: "China" },
  { key: "jp", text: "Japón", value: "Japón" },
  { key: "ru", text: "Rusia", value: "Rusia" },
  { key: "au", text: "Australia", value: "Australia" },
  { key: "in", text: "India", value: "India" },
  { key: "za", text: "Sudáfrica", value: "Sudáfrica" },
  { key: "eg", text: "Egipto", value: "Egipto" },
];
